module.exports = __webpack_public_path__ + "static/media/taco-how-it-works.8540ef96.jpg";